import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';

import { E入力分類, E補助科目フラグ, Eフェーズ種別 } from '@/openapi/enum';
import { データListItemResponse, データApi, 勘定科目Api, 部門Api } from '@/openapi/user';

import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';
import C計画書データ表示設定CheckBox from '@/components/計画書データ表示設定CheckBox/計画書データ表示設定CheckBox.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import TabsMixin from '@/mixins/TabsMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import 資金繰り設定 from '@/entries/user/pages/authorized/事業所/計画書/計画/資金繰り予定/資金繰り設定/資金繰り設定.vue';
import 資金繰り表 from '@/entries/user/pages/authorized/事業所/計画書/計画/資金繰り予定/資金繰り表/資金繰り表.vue';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 資金繰りService, { 資金繰り予定 } from '@/classes/service/計画/資金繰りService';

export default mixins(RoutesMixin, TabsMixin, 事業所Mixin, 計画書Mixin).extend({
  name: 'P資金繰り予定',

  components: {
    tab0: 資金繰り設定,
    tab1: 資金繰り表,
    MoneyUnitSelect,
    C計画書データ表示設定CheckBox,
  },

  data(): {
    tabs: string[];
    service: 資金繰りService;
    資金繰り予定: 資金繰り予定 | null;
  } {
    return {
      tabs: ['資金繰り表（設定）', '資金繰り表'],
      service: new 資金繰りService(Eフェーズ種別.計画フェーズ),
      資金繰り予定: null,
    };
  },

  async created(): Promise<void> {
    await this.$_load();
  },

  methods: {
    changeTab(tabIndex: number): void {
      this.setTabIndex(0, tabIndex);
      if (this.資金繰り予定 === null || tabIndex === 0) return;

      const 資金繰り予定 = this.資金繰り予定;
      this.service.update開始月(資金繰り予定);

      this.service.calculateConfigValues(資金繰り予定.value);
      this.$_updateValueTable(資金繰り予定);
    },
    onChange0円非表示フラグ(): void {
      this.$_updateValueTable(this.資金繰り予定!);
    },

    async $_load(): Promise<void> {
      const 勘定科目Request = UserApiUtility.ogApi(勘定科目Api).list勘定科目(
        this.事業所.pk,
        E補助科目フラグ.通常,
        undefined,
        undefined,
        { params: { sj: '資金繰り予定_勘定科目' } }
      );
      const 部門Request = UserApiUtility.ogApi(部門Api).list部門(this.事業所.pk);

      // Promise を直接再利用すると通信が行われないため、都度生成する
      const createデータRequest = (): Promise<AxiosResponse<データListItemResponse[]>> =>
        UserApiUtility.ogApi(データApi).listデータ(this.計画書.pk, this.service.getRelationalE入力分類s(), undefined, {
          params: { sj: '資金繰り予定' },
        });

      const responses = await Promise.all([勘定科目Request, 部門Request, createデータRequest()]);
      this.service.set勘定科目s = responses[0].data;
      this.service.set部門s = responses[1].data;
      this.資金繰り予定 = this.service.parse(responses[2].data);

      if (this.資金繰り予定!.データpk !== undefined) return;

      // 資金繰り予定データが存在しない場合は空データを登録した後に再取得
      await UserApiUtility.ogApi(データApi).createデータ(this.計画書.pk, {
        c入力分類: E入力分類.資金繰り,
        c番号: 0,
        cフェーズ種別: Eフェーズ種別.計画フェーズ,
        cデータ: JSON.stringify(this.service.cデータ資金繰り),
      });
      this.資金繰り予定 = this.service.parse((await createデータRequest()).data);
    },
    $_updateValueTable(資金繰り予定: 資金繰り予定): void {
      const value = 資金繰り予定.value;
      this.service.calculateSums(value);
      資金繰り予定.valueTable = this.service.createValueTable(value);
    },
  },
});
